const TableMessage = ({ children }) => {
  return (
    <div className="w-full uppercase flex justify-center items-center h-[120px] font-interMedium text-codiDarkGray">
      {children}
    </div>
  );
};

export default TableMessage;
